import {formatDate, parseDateTime} from '../../lib/dates'

export default {
  methods: {
    formatDate,
    parseDateTime
  },

}

